import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../authentication/authentication.service';
import { Observable } from 'rxjs';
import { CarrierType, AccountRoles } from '../../shared/constants/account-roles.enum';
import { RequestListMode } from '../../shared/constants/request-list-mode';

@Injectable()
export class FirstLoadGuard implements CanActivate {
    constructor(
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router) {
        }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        return this.authService.getUserClaims().pipe(
            map(claims => {
                const isPreRegistration = JSON.parse(localStorage.getItem('isPreRegistration'));
                if(isPreRegistration) {
                    this.router.navigate(['/']);
                    return false;
                }
                const callbackUrl = localStorage.getItem('callback_url');
                if (callbackUrl) {
                    this.router.navigate([callbackUrl]);
                } else if (claims && claims.role.toLowerCase() === AccountRoles.Carrier && claims.type === CarrierType.Operation) {
                    this.router.navigate([`/request/${RequestListMode.Deal}`]);
                } else {
                    this.router.navigate([`/request/${RequestListMode.List}`]);
                }

                return true;
            })
        );
    }
}
